import React from 'react';
import {
  Form,
  Checkbox,
  DatePicker,
  Input,
  Divider,
  Select,
  Dropdown,
  Menu,
  Icon,
  InputNumber,
  Radio,
} from 'antd';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import * as api from '../../../stores/api'

import FieldUpload from './FieldUpload';
import AddEditStore from './Store';

@observer
class ClaimDetails extends React.Component {
  render() {
    const itemModel = toJS(AddEditStore.assessmentInfo);
    return (
      <Form name="claim-details">
        <div className="fluid-field checkbox-field">
          <Checkbox
            checked={itemModel.OldBilled}
            disabled={itemModel.isLocked || itemModel.PaperWorkReceived}
          >
            Old-Billed
          </Checkbox>
        </div>
        <Form.Item label="Request Date">
          <DatePicker
            size="large"
            value={itemModel.InjuriedDate}
            disabled={itemModel.isLocked || !api.isAdminOrMagStaffOrAccounting}
          />
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              PIC 1<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Thomas Hiep Pham</Select.Option>
          </Select>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Notify CM of Appointment Request</Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Notify Doctor of Appointment Request</Checkbox>
        </div>
        <Form.Item className="fluid-field" label="Inquiry Notes">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Booking Client</h3>
        <Form.Item
          required
          label={
            <React.Fragment>
              Booking Client
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Client</Menu.Item>
                    <Menu.Item>Edit Client</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 2767 3M</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Purchase Order No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Authorised Purchase Amount">
          <InputNumber
            size="large"
            formatter={value =>
              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Approved Disbursement Funding">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Use Funding for this Booking</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              Client Account Manager
              <button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff Daniel</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          required
          label={
            <React.Fragment>
              Booking CM
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Case Manager</Menu.Item>
                    <Menu.Item>Edit Case Manager</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 13784</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Booking Solicitor
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Solicitor</Menu.Item>
                    <Menu.Item>Edit Solicitor</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 13784</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Report Delivery Contact 1">
          <Select size="large" value="1">
            <Select.Option value="1">No. 13784</Select.Option>
          </Select>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send to Booking CM</Checkbox>
        </div>
        <Form.Item label="Report Delivery Contact 2">
          <Select size="large" value="1">
            <Select.Option value="1">No. 13784</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Client Officer
              <button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">MAG Accounts</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Sub-Booking Client
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Client</Menu.Item>
                    <Menu.Item>Edit Client</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 2767 3M</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Sub-Booking CM / Solicitor">
          <Select size="large" value="1">
            <Select.Option value="1">No. 10000</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Where did you originally hear about us?">
          <Select size="large" value="1">
            <Select.Option value="1">Newsletter</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Where did you hear about the doctor for today booking?">
          <Select size="large" value="1">
            <Select.Option value="1">Newsletter</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          className="fluid-field"
          label="What else could we do to improve our service offering to you?"
        >
          <Input.TextArea rows={6} />
        </Form.Item>
        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Claimant Details</h3>
        <Form.Item
          required
          label={
            <React.Fragment>
              Booking Claimant
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Claimant</Menu.Item>
                    <Menu.Item>Edit Claimant</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 10001</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Claimant Title">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Claimant Name">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Date of Birth">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Claimant Email">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Mobile phone">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Reference/Claim No" required>
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Client File No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Type of Claim" required>
          <Select size="large" value="1">
            <Select.Option value="1">ComcareX</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Type of Report" required>
          <Select size="large" value="1">
            <Select.Option value="1">123</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Required Specialty">
          <Select size="large" value="1">
            <Select.Option value="1">Dentist</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Required Sub-Specialty">
          <Select size="large" value="1">
            <Select.Option value="1">Dentist</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Date of Injury">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Injury Description">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Employer Of Claimant">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Appointment Preference">
          <DatePicker.RangePicker size="large" />
        </Form.Item>
        <Form.Item label="Location">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Specialties">
          <Select size="large" value="1">
            <Select.Option value="1">Dentist</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item className="fluid-field" label="Location">
          <Input.TextArea rows={6} />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Report Funded by WIRO/ILARS</Checkbox>
        </div>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attach Funding Approval"
        />
        <Form.Item label="ILARS Ref">
          <Input size="large" disabled />
        </Form.Item>
        <Form.Item label="Billing Item Code">
          <Select size="large" value="1" disabled>
            <Select.Option value="1">IMS001</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="WIRO Principal Lawyer" style={{ marginBottom: 0 }}>
          <Select size="large" value="1" disabled>
            <Select.Option value="1">CaseManager 12372</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    );
  }
}

export default ClaimDetails;
